import { Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';

@Component({
  selector: 'formly-currency-mask',
  template: `
  <input matInput
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [prefix]="currencyPrefix"
  [mask]="to.ngxMask?.mask"
  [thousandSeparator]="to.ngxMask?.thousandSeparator">
  `
})
export class FormlyCurrencyTypeComponent extends FieldType<FieldTypeConfig> {
    currencyPrefix: string | null = '';
    constructor(private localeSettingService: LocaleSettingService) {
        super();
        this.currencyPrefix = this.localeSettingService.getLocaleCurrencySymbol();
    }
}
